<template>
  <div :id="name"></div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen.js';

import L from "leaflet";
import { GestureHandling } from "leaflet-gesture-handling";

export default {
  props: ["name", "lat", "lng"],

  data() {
    return {
      map: null,
    };
  },

  computed: {
    centerLocation() {
      if (this.lat === null || this.lng === null) {
        return null;
      } else {
        return [this.lat, this.lng];
      }
    },
  },

  mounted() {
    L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

    this.map = L.map(this.name, {
      center: this.centerLocation,
      zoom: 7,
      scrollWheelZoom: false,
      layers: [
        L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }),
      ],
      gestureHandling: true,
      fullscreenControl: true
    });

    if (this.centerLocation !== null) {
      L.marker(this.centerLocation).addTo(this.map);
    }
  },
};
</script>
